export function getGradientColor(v: number) {
    return GRADIENT[Math.floor((1.0 - v) * (GRADIENT.length - 1))];
}

export const GRADIENT = [
    "#fb0400",
    "#f70800",
    "#f30c00",
    "#ef1000",
    "#eb1400",
    "#e71800",
    "#e41b00",
    "#e01f00",
    "#dc2300",
    "#d82700",
    "#d42b00",
    "#d02f00",
    "#cc3300",
    "#c83700",
    "#c43b00",
    "#c03f00",
    "#bc4300",
    "#b84700",
    "#b44b00",
    "#b14e00",
    "#ad5200",
    "#a95600",
    "#a55a00",
    "#a15e00",
    "#9d6200",
    "#996600",
    "#956a00",
    "#916e00",
    "#8d7200",
    "#897600",
    "#857a00",
    "#817e00",
    "#7e8100",
    "#7a8500",
    "#768900",
    "#728d00",
    "#6e9100",
    "#6a9500",
    "#669900",
    "#629d00",
    "#5ea100",
    "#5aa500",
    "#56a900",
    "#52ad00",
    "#4eb100",
    "#4bb400",
    "#47b800",
    "#43bc00",
    "#3fc000",
    "#3bc400",
    "#37c800",
    "#33cc00",
    "#2fd000",
    "#2bd400",
    "#27d800",
    "#23dc00",
    "#1fe000",
    "#1be400",
    "#18e700",
    "#14eb00",
    "#10ef00",
    "#0cf300",
    "#08f700",
    "#04fb00",
];
